<template>
  <div class="verify-dialog">
    <el-dialog
      title="请扫描二维码"
      width="30%"
      :visible.sync="myValue"
      :close-on-click-modal="false"
      @close="close"
    >
      <div class="qr-box">
        <el-image :src="qrUrl"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      myValue: this.value,
      qrUrl: require('../assets/images/qr.png')
    }
  },
  watch: {
    value (val) {
      this.myValue = val
    }
  },
  created () {
  },
  mounted () {},
  methods: {
    cancel () {
      this.myValue = false
    },
    confirm () {
      this.myValue = false
    },
    close () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.qr-box {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/previewDialog.vue